import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import globalMutations from "./mutations";
import globalActions from "./actions";
import globalGetters from "./getters";

import weather from "./modules/weather";
import sensor from "./modules/sensor";
import dataPolice from "./modules/dataPolice";
import monitor from "./modules/monitor";
import map from "./modules/map";
import dynamic from "./modules/dynamic";
import trace from "./modules/trace";
import envChart from "./modules/envChart";

export default new Vuex.Store({
  state: {
    farmId: "",
    roomId: null,
    deviceClass: [],
    roomList: [],
    fruitCategory: []
  },
  getters: {
    ...globalGetters
  },
  mutations: {
    ...globalMutations
  },
  actions: {
    ...globalActions
  },
  modules: {
    weather: {
      namespaced: true,
      ...weather
    },
    sensor: {
      namespaced: true,
      ...sensor
    },
    dataPolice: {
      namespaced: true,
      ...dataPolice
    },
    monitor: {
      namespaced: true,
      ...monitor
    },
    map: {
      namespaced: true,
      ...map
    },
    dynamic: {
      namespaced: true,
      ...dynamic
    },
    trace: {
      namespaced: true,
      ...trace
    },
    envChart: {
      namespaced: true,
      ...envChart
    }
  },
});
